import TableHeaderHtmlCustom from '../../../../components/common/customTable/TableHeaderHtmlCustom';
import { TableCompHead } from '../../../../components/ui';
import { useQuery } from '../../../../hooks/UseQuery';
import { moduleConstant } from '../constant';

const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
  minWidth: '100px',
  height: '50px',
};
const style2 = {
  backgroundColor: '#00B050',
  color: '#fff',
  minWidth: '80px',
};

interface IProps {
  isView: boolean;
}

const THead = ({ isView }: IProps) => {
  const date = useQuery('date');
  const year = date && new Date(date).getFullYear();
  const tableHeaderObj = [
    [
      { text: 'S.No.'.toUpperCase(), style: style1, rowspan: 1 },
      { text: 'Machine No.'.toUpperCase(), style: style1, rowspan: 1 },
      {
        text: 'Location'.toUpperCase(),
        style: style1,
        rowspan: 1,
      },
      {
        text: 'Available time minutes'.toUpperCase(),
        style: style1,
        rowspan: 1,
      },
      { text: 'Down time (Min)'.toUpperCase(), style: style1, rowspan: 1 },
      { text: 'No. of Down time'.toUpperCase(), style: style1, rowspan: 1 },
      { text: 'MTBF'.toUpperCase(), style: style1, rowspan: 1 },
      { text: 'MTTR'.toUpperCase(), style: style1, rowspan: 1 },
      // { text: 'Action'.toUpperCase(), style: style1, rowspan: 1 },
    ],
  ];
  return (
    <thead
      style={{
        position: 'sticky',
        width: '100%',
        top: '-.5rem',
        border: '1px solid black',
        zIndex: '1',
        backgroundColor: '#38d9a9',
        color: 'black',
      }}
    >
      <TableCompHead
        colSpan={8}
        rowSpan={3}
        labels={['F.NO.:', 'REV. NO.', 'Date']}
        values={['HO-F-MNT-12', '00', '01.09.2013']}
        heading={`${moduleConstant?.heading} - ${year}`}
      />
      <TableHeaderHtmlCustom tableHeaderObj={tableHeaderObj} />
    </thead>
  );
};

export default THead;
